export const SUPER_ADMIN = 'Super Admin';
export const SUPER_ADMIN_SLUG = 'super-admin';
export const SUPER_ADMIN_CODE = 1;

export const USER = 'User';
export const USER_SLUG = 'user';
export const USER_CODE = 2;

export const OWNER = 'Owner';
export const OWNER_SLUG = 'owner';
export const OWNER_CODE = 3;